import React from 'react'
import $t from '../../../i18n'
import { Button, Spin } from 'antd'
import cx from 'classnames'
import FamilyMemberLabel from '../FamilyMemberLabel/FamilyMemberLabel'
import { clinicName } from '../../../utils/clinicsUtils'

import './ListView.css'
import { useSelector } from 'react-redux'
import EmptyList from '../EmptyList'
import NotInsuredLabel from '../NotInsuredLabel'
import CardListItem from '../CardListItem'
import { CARD_LIST_ITEM_IMAGE } from '../../../consts/CardListItemConsts'

export const ListItem = ({
  issueDate,
  title,
  doctor,
  dateRange,
  comment,
  onClick,
  index,
  isPressable,
  antidote_clinic,
  isFollowUp,
  shouldHideClinicName,
  isSeen,
  dataName = '',
  actions,
  patientId,
}) => {
  const { activeMembers } = useSelector(state => state.account)
  const isFamily = !!activeMembers?.length

  return (
    <ul
      key={index}
      className={cx('list-item trackable', { pressable: isPressable })}
      onClick={onClick}
      data-name={dataName}
    >
      <div className="column streach">
        {isFamily && patientId && <NotInsuredLabel patientId={patientId} />}
        <div className="row">
          {isFamily && patientId && <FamilyMemberLabel patientId={patientId} />}
          <li className="streach column date-range">
            {issueDate}
            {isSeen === false ? (
              <span className="new-tag">{$t('referrals.new')}</span>
            ) : null}
          </li>
        </div>

        <div className="row wrap">
          <li className="name streach item column">
            {shouldHideClinicName
              ? title
              : `${title} | ${clinicName(antidote_clinic, isFollowUp)}`}
          </li>
          <li className="streach doctor-and-comment item column">
            <div className="column">
              {doctor?.firstName
                ? `Dr. ${doctor?.firstName} ${doctor?.lastName}`
                : doctor}
              {comment && <div className="comment column">{comment}</div>}
            </div>
          </li>
          {dateRange && <li className="item column">{dateRange}</li>}
          <li className="row item">
            {!!actions &&
              actions?.map((action, i) => (
                <Button
                  className="pills"
                  type={i === 0 ? 'primary' : 'outline'}
                  style={i === 0 ? { marginLeft: 0 } : { marginLeft: 10 }}
                  onClick={action?.onClick}
                >
                  {action?.title}
                </Button>
              ))}
          </li>
        </div>
      </div>
      <i className="icon-arrow-bold-right" data-hidden={!isPressable} />
    </ul>
  )
}

const ListView = ({ data, isLoading, dataName, category, emptyTitle }) => {
  return (
    <div className="list-view">
      {isLoading && <Spin size="large" />}
      {!isLoading &&
        (data && !!data?.length ? (
          data?.map(
            (
              {
                issueDate,
                title,
                doctor,
                dateRange,
                comment,
                onClick,
                isPressable,
                antidote_clinic,
                isFollowUp,
                isSeen,
                patientId,
                actions,
                shouldHideClinicName,
              },
              i
            ) => (
              <ListItem
                antidote_clinic={antidote_clinic}
                isFollowUp={isFollowUp}
                issueDate={issueDate}
                title={title}
                doctor={doctor}
                dateRange={dateRange}
                shouldHideClinicName={shouldHideClinicName}
                comment={comment}
                onClick={onClick}
                isPressable={isPressable}
                index={i}
                key={i}
                dataName={dataName}
                isSeen={isSeen}
                patientId={patientId}
                actions={actions}
              />
            )
          )
        ) : (
          <EmptyList title={emptyTitle || $t('alerts.noItems', { category })} />
        ))}
    </div>
  )
}

export default ListView
